import moment from "moment-timezone";

export default function getLocalTimezone(dateString, dateFormatString='MM/DD/YYYY') {
    const userTimezone = moment.tz.guess();

    return moment.tz(dateString, userTimezone).format(dateFormatString);
}
